export default {
  loading:true,
  user_last_modification:null,
  params_create:{
    results_account:0,
    document_transactions_count:0,
    code:null,
    name:null,
    short_name:null,
    description:null,
    debit_credit:null,
    group:null,
    level:null,
    account_id_totalize:null,
      account_for_search_document:null,
    category:null,
    branchoffice_id:null,
    line_id:null,
    contact_id:null,
    manage_contact_balances:null,
    is_customer:null,
    is_provider:null,
    is_employee:null,
    is_others:null,
    resume_beginning_year:null,
    wallet_type:null,
    document_description:null,
    manage_quota_balances:null,

    manage_document_balances:null,
    cost_center_2:null,
    cost_center_3:null,
    cost_center_1:null,
    manage_projects:null,
    manage_projects_stage:null,
    manage_bank_document:null,
    manage_way_to_pay:null,
    tax_id:null,
    Active_account:1,
    manage_documents:0,
    pevious_account:null,
    user_id:null,
    manage_base_value:null,
    commissionable_concept:0,
    contact_resume:null,
    bank_account:0,
    id_bank_account:null,
    branchoffice_warehouse_id:null,
    capture_contact: 0,
    capture_document: 0,
    application:[],
    manage_line:false,
  },
  loading_form:false,
  code_to_clone: null,
  code_to_edit: null,
  id_to_edit: null,

  groups:[],
  levels:[],
  accountss:[],
  banks_accounts:[],
  categories:[],
  branchOffices:[],
  contacts:[],
  wallet_types:[],
  cost_center_1:[],
  cost_center_2:[],
  cost_center_3:[],
  taxes:[],
  branchoffice_warehouses:[],
  commissionable_concepts:[],
  level_to_validate:null,

  paramsquery:{
    is_customer: false,
    is_provider: false,
    is_employee: false,
    filter_customer: [],
    filter_provider: [],
    filter_employee: [],
    paginate: true,
    page: 1,
    perPage: 50,
    query: '',
    sortBy: 'id',
    sort: 'ASC',
},
  disabled_input : false,
  params: {
    notAux: false,
    onlyAux : false,
    paginate: true,
    page: 1,
    perPage: 100,
    filter: "",
    sortBy: "code",
    sort: "ASC"
  },
  params_taxes: {
    page: 1,
    perPage: 100,
    filter: '',
    order:'asc'
  },
  accounts:[],
  subscriber:null
};



// WEBPACK FOOTER //
// ./src/modules/account/state.js